import { tabsComp } from '../modules/comp-tabs';

const pageBuilder = (data, gsap, mm, smoother, Swiper, Parallax, Navigation, Pagination, FreeMode, ScrollTrigger, barba) =>  {

  const $container = $(data.next.container);
  const $tabsComp = $container.find('.tabs-component');
  const $form = $container.find('.cta-form');
  const $pbCarousel = $container.find('.pb-carousel');
  const $caseStudies = $container.find('.pb__block-case-studies-component .csf-desktop');
  
  function noBodyScroll() {
    $('html, body').addClass('superlock');
    setTimeout(() => {
      smoother.paused(true);
    }, 300);
    ScrollTrigger.refresh();
  }

  function yesBodyScroll() {
    smoother.paused(false);
    $('html, body').removeClass('superlock');
    ScrollTrigger.refresh();
  }
  
  if ($pbCarousel.length) {
    $pbCarousel.each(function(i, el) {
      const $this = el;
      const pagination = el.querySelector('.pb-carousel-pagination');
      const next = el.querySelector('.pb-carousel-next');
      const prev = el.querySelector('.pb-carousel-prev');
      const lpTeamSwiper = new Swiper($this, {
        modules: [Navigation, Pagination, Parallax, FreeMode],
        speed: 1000,
        autoHeight: true,
        parallax: true,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        pagination: {
          el: pagination,
          type: "fraction",
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
      
    });
  }
  
  mm.add("(min-width: 62rem)", () => {
    
    if ($form.length) {
        
        $form.each(function() {
          const $this = $(this);
          smoother.effects($this, {speed: 1.2});
        })
        
    }
    
    if ($caseStudies.length) {
      
      const $studies = $caseStudies.find('.csf-item');
      const $modal = $('.csf-modal');
      const $overlay = $('.csf-overlay');
      const close = $modal.find('.close');
      const $csfBtn = $modal.find('.barba-link');
      const $modalContent = $('.csf-modal .content');
      const $modalCats = $('.csf-modal .cats');
      const $modalTitle = $('.csf-modal .csf-title');
      const $modalText = $('.csf-modal .overview-text');
      const $modalLink = $('.csf-modal a.cta-sm');
      
      const $modalTransplant = $modal.detach();
  
      $('body').append($modalTransplant);
      
      $studies.each(function() {
        
        const $this = $(this);

        $this.on('click', (e)=> {
          
          e.preventDefault();
          
          let $this = $(this),
              $title = $this.find('.title').text(),
              $cats = $this.data('cats'),
              $url = this.pathname,
              $content = $this.find('span.sr-only').html();
          
          if (!$modal.is('.active')) {
            
            $modal.add($caseStudies).addClass('active');
            
            noBodyScroll();
            
            $modalCats.text($cats);
            $modalTitle.text($title);
            $modalText.html($content);
            $modalLink.attr('data-href', $url);
            
            $modalContent.addClass('active');

          }

        });
        
      });
      
      $csfBtn.on('click', function() {
        const url = $(this).data('href');
        smoother.paused(false);
        $('html, body').removeClass('superlock');
        barba.go(url);
      });
      
      $overlay.add(close).on('click', () => {
        if ($modal.is('.active')) {
          $modal.add($caseStudies).add($modalContent).removeClass('active');
          yesBodyScroll();
          setTimeout(() => {
            $modalCats.text('');
            $modalTitle.text('');
            $modalText.html('');
            $modalLink.attr('data-href', '');
          }, 400);
        }
      });
      
    }
    
  });
  
  if ($tabsComp.length) {
    tabsComp(data, gsap, smoother);
  }
  
}

export {
  pageBuilder
}